<template>
  <div class="work_detail">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img v-if="URL_MAQIN==1" src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <!-- <el-breadcrumb-item  to="visit_class" >课程详情</el-breadcrumb-item> -->
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="jion clearfix" v-show="join_show" @click="join_click">
          <img src="../assets/img/add.png" alt />
          {{addClassContent.title||'加入班群'}}
        </div>
        <div
          class="time_left clearfix"
          v-if="has_exam_date!=0"
        >
          <img v-if="URL_MAQIN==2" src="../assets/img/kjctime.png" alt />
          <img v-if="URL_MAQIN==1" src="../assets/img/time.png" alt />

          <div class="text" v-if="!tip">
            距离考试还有
            <span>{{exam_time}}</span> 天，抓紧时间学习啦
          </div>
          <div class="text" v-else>
            {{tip}}
          </div>
        </div>
      </div>
      <div class="content_box clearfix">
        <div class="content_box_l">
          <div class="content_box_l_title">已报课程</div>
          <div
            class="class_list"
            :class="item.title ==title? 'active':''"
            v-for="(item,index) in title_list"
            :key="index"
            @click="chuange_class(item.course_id,item.chapter_id,item.title)"
          >{{item.title}}</div>



          <button class="zhinengBtn" @click="fkShowM(2)" v-if="isFkShow==1">高频考点训练营 >></button>
          <button class="zhinengBtn" @click="fkShowM(1)" v-else-if="isFkShow==2">‹‹  返回旧版</button>

          <a href="https://im.mifengdao.com/?is_study=1" target="_blank">
            <button style="width: 208px;height: 46px;background: #FADA1E;border-radius: 23px;border:none;position:absolute;bottom:-146px;left:30px;display:flex;justify-content:center;align-items:center;cursor:pointer">
              <img src="@/assets/img/teacher.png" alt="" style="width:23px;height:23px;margin-right:11px">问老师
            </button>
          </a>
        </div>
        <div class="content_box_r">
          <div class="valid_time" v-show="join_show">
            课程有效时间：
            <span>{{expire_time}}</span>
          </div>
          <div class="question_top clearfix">
            <div class="question_top_l">
              <div class="sort">
                <div class="sort_item" @click="bad_click(wrong.params.subject_id,wrong.wrongCount)">
                  <div class="number" v-if="wrong.wrongCount">{{wrong.wrongCount}}</div>
                  <div class="number" v-else>0</div>
                  <div class="title">我的错题</div>
                </div>
                <div class="sort_item" @click="favorite_click(favorite)">
                  <div class="number" v-if="favorite.favoriteCount">{{favorite.favoriteCount}}</div>
                  <div class="number" v-else>0</div>
                  <div class="title">我的收藏</div>
                </div>
                <div class="sort_item" @click="question(comments.commentsCount)">
                  <div class="number" v-if="comments.commentsCount">
                    {{comments.commentsCount}}
                    <span v-if="comments.status==1"></span>
                  </div>
                  <div class="number" v-else>0</div>
                  <div class="title">我的提问</div>
                </div>
              </div>
            </div>
            <div class="question_top_r">
              <!-- lore知识点 -->
              <div class="over_lore clearfix">
                <div class="name">已练习题目：</div>
                <div class="proge">
                  <el-progress :percentage="over" :show-text="false" :stroke-width="18"></el-progress>
                </div>
                <div class="number">
                  <span>{{points.do_points}}</span>
                  /{{points.total_points}}
                </div>
              </div>
              <div class="over_lore clearfix">
                <div class="name">题目正确率：</div>
                <div class="proge1">
                  <el-progress :percentage="over1" :stroke-width="18"></el-progress>
                </div>
              </div>
            </div>
          </div>
          <div class="question_bottom clearfix">
            <div
              class="type_item clearfix"
              v-for="(item,index) in level_data"
              :key="index"
              @click="chapter_click(item.course_id,item.id,item.title,item.level_type,item)"
              v-if="item.is_show==1&&item.is_ai_chapter!=1||item.is_ai_chapter==1&&isFkShow==2"
            >
              <img :src="item.m_thumb" alt />
              <span>{{item.title}}</span>
            </div>
          </div>
          
          <div class="adImg"  @click="adClick(adInfo.link)" v-if="adInfo">
            <img :src="adInfo.content" alt="" style="margin:40px;width:calc(100% - 80px);border-radius:8px;cursor:pointer">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Questions, ClassTitle,billing,levelContent,ExamTime } from "@/api/index";
export default {
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      level_data: [], //分类
      wrong: {}, //错题
      favorite: {}, //收藏
      comments: {}, //提问
      expire_time: "",
      points: {}, //正确率
      over: 0, //
      over1: 0,
      title: "", //顶部标题
      title_list: [], //
      chapter_id: "",
      course_id: "",
      levelList: {},
      join_show: false,
      adInfo:'',
      addClassContent:'',
      tip:'',
      exam_time:'',
      has_exam_date:'',
      learn_type:'',//初级中级
      isFkShow:0,
      
    };
  },

  async mounted() {
    // this.title = this.$route.query.name;
    this.course_id = this.$route.query.course_id;
    let course_id = sessionStorage.getItem("course_id");
    let chapter_id = sessionStorage.getItem("chapter_id");
    // this.request(course_id, chapter_id);
    if (this.$route.query.name) {
      await this.request(course_id, chapter_id);
      this.chapter_id = sessionStorage.getItem("chapter_id");
    } else {
      await this.request(this.$route.query.course_id, this.$route.query.chapter_id);
      this.chapter_id = this.$route.query.chapter_id;
    }
    if (this.$route.query.type) {
      this.join_show = true;
    }
    // this.request(this.$route.query.course_id, this.$route.query.chapter_id);
    this.getbilling(8,this.$route.query.course_id);
    this.joinClass(this.$route.query.course_id);

    // 获取智能练习显示
    let intelligence = localStorage.getItem('intelligence')
    for(let item of this.level_data){
      console.log(item)
      if(item.is_ai_chapter==1){
        this.isFkShow = 1
        if(intelligence){
          intelligence = JSON.parse(localStorage.getItem('intelligence'))
          console.log(intelligence)
          for(let item of intelligence){
            if(item.course_id==this.$route.query.course_id&&item.chapter_id==this.$route.query.chapter_id){
              this.isFkShow = item.is_show
              break;
            }
          }
        }
        break;
      }else{
        this.isFkShow = 0
      }
    }
    console.log(this.isFkShow)
  },
  methods: {
    fkShowM(num){
      this.isFkShow=num
      // 缓存
      let intelligence = localStorage.getItem('intelligence')
      if(intelligence) intelligence = JSON.parse(localStorage.getItem('intelligence'))
      else intelligence = []
      
      let isHas = false
      for(let item of intelligence){
        if(item.course_id==this.$route.query.course_id&&item.chapter_id==this.$route.query.chapter_id){
          item.is_show = num
          isHas=true
          break;
        }
      }
      if(!isHas){
        intelligence.push({course_id:this.$route.query.course_id,chapter_id:this.$route.query.chapter_id,is_show:num})
      }
      localStorage.setItem('intelligence',JSON.stringify(intelligence))
    },
    // 加入班群
    joinClass(course_id){
      levelContent(course_id,13).then(res=>{//this.v_id
        // console.log(res)
        this.addClassContent = res
      })
    },
    adClick(url){
      // window.location.href = url;
      window.open(url)
    },
    async request(course_id, chapter_id) {
      await ExamTime(course_id).then(res => {
        // console.log(res);
        this.has_exam_date = res.has_exam_date
        this.tip = res.exam_notice;
        this.exam_time = res.exam_time;
      });
      await Questions(course_id, chapter_id).then(res => {
        this.level_data = res.level_data;
        this.wrong = res.wrong;
        this.favorite = res.favorite;
        this.comments = res.comments;
        this.points = res.points;
        this.expire_time = res.expire_time;
        this.learn_type = res.course_info.learn_type
        // this.over1 = res.points.ratio;
        if (res.points.total_points) {
          this.over = parseInt(
            (
              (parseInt(res.points.do_points) /
                parseInt(res.points.total_points)) *
              100
            ).toFixed(0)
          );
          if (
            parseInt(res.points.do_points) - parseInt(res.points.ratio) ==
            0
          ) {
            this.over1 = 0;
          } else {
            this.over1 = parseInt(
              (
                ((parseInt(res.points.do_points) - parseInt(res.points.ratio)) /
                  parseInt(res.points.do_points)) *
                100
              ).toFixed(0)
            );
          }
        } else {
          this.over1 = 0;
        }
        console.log(parseInt(res.points.do_points));
      });

      ClassTitle(course_id).then(res => {
        console.log(res);
        this.title_list = res;
        if (this.chapter_id == 0) {
           this.title=this.title_list[0].title
        } else {
          for (let i = 0; i < this.title_list.length; i++) {
            if (this.title_list[i].chapter_id == this.chapter_id) {
              this.title = this.title_list[i].title;
              // console.log(this.title_list[i],'xiangdeng');
            }
          }
        }
      });
    },

    // 点击顶部切换课程
    chuange_class(course_id, chapter_id, title) {
      this.request(course_id, chapter_id);
      // this.title = title;
      this.chapter_id = chapter_id;
      sessionStorage.setItem("course_id", course_id);
      sessionStorage.setItem("chapter_id", chapter_id);
    },
    close_overlay() {
      this.top_show = false;
      this.show = false;
    },
    // 章节练习
    chapter_click(course_id, id, title, level_type,item) {
      let _this = this;
      // 蜂狂训练营
      if(item.is_ai_chapter==1&&item.ai_type==1){
        return this.$router.push({
          path: "fkxly",
          query: {
            course_id: course_id,
            id: id,
            title: title,
            chapter_id: _this.chapter_id
          }
        });
      }else if(item.is_ai_chapter==1&&item.ai_type==2){
        return this.$router.push({
          path: "mockZujuan",
          query: {
            course_id: course_id,
            id: id,
            title: title,
            chapter_id: _this.chapter_id
          }
        });
      }


      if (level_type == 3) {
        this.$router.push({
          path: "exam_list",
          query: {
            course_id: course_id,
            id: id,
            title: title,
            toptitle: this.title,
            learn_type:this.learn_type
          }
        });
      } else {
        this.$router.push({
          path: "exercise_list",
          query: {
            course_id: course_id,
            id: id,
            title: title,
            toptitle: this.title,
            learn_type:this.learn_type
          }
        });
      }
    },
    // 广告
    getbilling(id,course_id){
      billing(id,course_id).then(res=>{
        if(res.length>0)
          this.adInfo=res[0]
      })
    },
    bad_click(subject_id, wrongCount) {
      if (wrongCount == 0 || wrongCount == null) {
      } else {
        if (subject_id) {
          this.$router.push({
            path: "assemble",
            query: {
              subject_id: subject_id,
              chapter_id: this.chapter_id,
              type: 1
            }
          });
        }
      }
    },
    // 点击收藏
    favorite_click(favorite) {
      if (favorite.favoriteCount == null || favorite.favoriteCount == 0) {
      } else {
        this.$router.push({
          path: "assemble",
          query: {
            subject_id: favorite.params.subject_id,
            chapter_id: this.chapter_id,
            type: 2
          }
        });
      }
    },
    question(commentsCount) {
      if (commentsCount) {
        this.$router.push({
          path: "my_questions",
          query: { course_id: this.comments.course_id, id: this.comments.id }
        });
      }
    },
    // 加入班群
    join_click() {
      this.$router.push({
        path: "join",
        query: { chapter_id: this.chapter_id, course_id: this.course_id ,type:this.addClassContent.title||'加入班群'}
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
    .jion {
      cursor: pointer;
      float: right;
      line-height: 24px;
      padding-right: 24px;
      img {
        float: left;
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    .time_left {
      float: left;
      margin-left: 70px;

      img {
        float: left;
        width: 31px;
        height: 31px;
        margin-right: 16px;
      }

      .text {
        float: left;
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        span {
          color: #fe4c4b;
          font-size: 26px;
          font-weight: Medium;
        }
      }
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      position: relative;
      .zhinengBtn{
        width: 208px;
        height: 46px;
        background: #FADA1E;
        border-radius: 23px;
        position: absolute;
        bottom: -78px;
        left: 30px;
        border: 0;
        cursor: pointer;
      }
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: rgba(250, 220, 30, 1);
      }
    }
    .content_box_r {
      float: right;
      width: 1067px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      .valid_time {
        padding: 20px 37px 0px 44px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        span {
          color: #fe4c4b;
        }
      }
      .question_top {
        padding: 40px 37px 40px 44px;
        border-bottom: 1px solid #eee;
        .question_top_l {
          .sort {
            .sort_item {
              cursor: pointer;
              float: left;
              margin-right: 86px;
              &:last-of-type {
                margin-right: 0;
              }
              .number {
                position: relative;
                font-size: 32px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 23px;
                text-align: center;
                span {
                  position: absolute;
                  top: 0;
                  right: 0;
                  display: block;
                  width: 12px;
                  height: 12px;
                  background: rgba(232, 66, 51, 1);
                  border-radius: 50%;
                }
              }
              .title {
                font-size: 18px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
              }
            }
          }
        }
        .question_top_r {
          float: right;
          .over_lore {
            margin-bottom: 26px;
            .name {
              float: left;
              line-height: 26px;
            }
            .proge {
              float: left;
              width: 250px;
              margin: 0 5px 0 15px;
              margin-top: 5px;
            }
            .proge1 {
              float: left;
              width: 300px;
              margin: 0 15px;
            }
            .number {
              float: left;
              font-size: 20px;
              font-weight: 400;
              color: #333333;
              span {
                color: #e84233;
              }
            }
          }
        }
      }
      .question_bottom {
        padding: 40px 38px;
        .type_item {
          cursor: pointer;
          float: left;
          width: 189px;
          background: rgba(247, 247, 247, 1);
          border-radius: 11px;
          padding: 28px 10px;
          margin-right: 31px;
          margin-bottom: 32px;
          display: flex;
          align-items: center;
          img {
            // float: left;
            width: 46px;
            height: 46px;
            margin: 0 18px;
          }
          span {
            // display: block;
            // float: left;
            // line-height: 46px;
          }
        }
      }
    }
  }
}
.main_kjc {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
    .jion {
      cursor: pointer;
      float: right;
      line-height: 24px;
      padding-right: 24px;
      img {
        float: left;
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    .time_left {
      float: left;
      margin-left: 70px;

      img {
        float: left;
        width: 31px;
        height: 31px;
        margin-right: 16px;
      }

      .text {
        float: left;
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        span {
          color: #fe4c4b;
          font-size: 26px;
          font-weight: Medium;
        }
      }
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: #fff;
        background: #0cd56d;
      }
    }
    .content_box_r {
      float: right;
      width: 1067px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      .valid_time {
        padding: 20px 37px 0px 44px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        span {
          color: #fe4c4b;
        }
      }
      .question_top {
        padding: 40px 37px 40px 44px;
        border-bottom: 1px solid #eee;
        .question_top_l {
          .sort {
            .sort_item {
              cursor: pointer;
              float: left;
              margin-right: 86px;
              &:last-of-type {
                margin-right: 0;
              }
              .number {
                position: relative;
                font-size: 32px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 23px;
                text-align: center;
                span {
                  position: absolute;
                  top: 0;
                  right: 0;
                  display: block;
                  width: 12px;
                  height: 12px;
                  background: rgba(232, 66, 51, 1);
                  border-radius: 50%;
                }
              }
              .title {
                font-size: 18px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
              }
            }
          }
        }
        .question_top_r {
          float: right;
          .over_lore {
            margin-bottom: 26px;
            .name {
              float: left;
              line-height: 26px;
            }
            .proge {
              float: left;
              width: 250px;
              margin: 0 5px 0 15px;
              margin-top: 5px;
            }
            .proge1 {
              float: left;
              width: 300px;
              margin: 0 15px;
            }
            .number {
              float: left;
              font-size: 20px;
              font-weight: 400;
              color: #333333;
              span {
                color: #e84233;
              }
            }
          }
        }
      }
      .question_bottom {
        padding: 40px 38px;
        .type_item {
          cursor: pointer;
          float: left;
          width: 189px;
          background: rgba(247, 247, 247, 1);
          border-radius: 11px;
          padding: 28px 10px;
          margin-right: 31px;
          margin-bottom: 32px;
          display: flex;
          align-items: center;
          img {
            // float: left;
            width: 46px;
            height: 46px;
            margin: 0 18px;
          }
          span {
            // display: block;
            // float: left;
            // line-height: 46px;
          }
        }
      }
    }
  }
}
.work_detail{
  margin-bottom: 150px;
}
</style>
<style lang="scss">
.main_mfd {
  .el-progress-bar__inner {
    background-color: #fadc1e;
  }
}
.main_kjc {
  .el-progress-bar__inner {
    background-color: #0cd56d;
  }
}
.adImg{
  width: 100%;
  font-size: 0;
  cursor: pointer;
  // position: fixed;
  // bottom: 0;
  // left: 0;
  img{
    width: 100%;
  }
}
</style>
